import { Flex, FormItemsGroup, IconButton, Text } from '@billy/design-system'
import type { GridTemplateValue } from '@billy/design-system'
import { ReactElement } from 'react'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import type { InvoiceFormDepositLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormDepositLine'
import { formatDepositCurrencyAmount } from '@features/invoices/utils/depositInvoices/formatDepositCurrencyAmount'
import { useGetZervantDocumentSettings } from '@features/invoicingSettings/hooks/useGetZervantDocumentSettings'

import { useInvoiceEditorForm } from '../../../../../../../../../../contexts/invoiceEditorFormContext'
import { formatVatRatePercent } from '../../utils/formatVatRatePercent'

interface DepositInvoiceSingleVatLineProps {
  columnItemsTemplate: GridTemplateValue[]
  depositLine: InvoiceFormDepositLine | undefined
  onEditClick: () => void
}

export const DepositInvoiceSingleVatLine = ({
  columnItemsTemplate,
  depositLine,
  onEditClick,
}: DepositInvoiceSingleVatLineProps): ReactElement => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { getInvoiceLocale } = useGetZervantDocumentSettings(InvoiceDocumentType.Invoice)

  const { watch } = invoiceEditorForm
  const currency = watch('currency')
  const locale = getInvoiceLocale()

  const vatRatePercentDisplay = formatVatRatePercent(depositLine?.vatRatePercent, locale)

  return (
    <FormItemsGroup itemsInRow={columnItemsTemplate.length} itemsTemplate={columnItemsTemplate}>
      <Text>{depositLine?.description}</Text>
      <Text alignment="right">
        {formatDepositCurrencyAmount(depositLine?.totalExcludingVat ?? 0, currency, locale)}
      </Text>
      <Text alignment="right">{vatRatePercentDisplay}</Text>
      <Text alignment="right">
        {formatDepositCurrencyAmount(depositLine?.totalIncludingVat ?? 0, currency, locale)}
      </Text>
      <Flex alignItems="center" justifyContent="flex-end">
        <IconButton onClick={onEditClick} icon="squarePen" size="sm" />
      </Flex>
    </FormItemsGroup>
  )
}
